module.exports = __webpack_public_path__ + "static/img/photovoltaic.20d7903.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photovoltaic.jpg
// module id = gDL6
// module chunks = 0